import gql from "graphql-tag";

const ACK_ALARMS_MUTATION = gql`
  mutation ReadNotification($notificationId: [Int!]) {
    ACKAlarms(notificationId: $notificationId)
  }
`;

export default ACK_ALARMS_MUTATION;
